import type { ReactNode } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";

export function ApproveTaskDialog({
  open,
  onOpenChange,
  inFlight,
  children,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  inFlight: boolean;
  children: ReactNode;
}) {
  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next && inFlight) return;
        onOpenChange(next);
      }}
    >
      <DialogContent
        className="max-w-md max-h-[90vh] overflow-y-auto"
        onInteractOutside={(e) => {
          if (inFlight) e.preventDefault();
        }}
        onEscapeKeyDown={(e) => {
          if (inFlight) e.preventDefault();
        }}
        onPointerDownOutside={(e) => {
          if (inFlight) e.preventDefault();
        }}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
}
